<div class="p-0" *ngIf="canSetAdditionalSteps">
  <form *ngIf="form" [formGroup]="form" class="mb-10">
    <div class="row">
      <div class="col-7 pr-0">
        <kt-general-autocomplete
          [appearance]="'outline'"
          [label]="'Template'"
          [loadItemsFunction]="templateAutocompleteCall"
          [optionFormatter]="filterTemplateFn"
          [valueFormatter]="filterTemplateFn"
          [control]="form.get('task_template')"
          [change]="onTemplateChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Template'"
          #templateAutocomplete
          [required]="true"
          [readOnly]="mode === 'view'"
        >
        </kt-general-autocomplete>
      </div>
      <div class="ks-pr-3">
        <button
          class="btn btn-icon btn-light ml-2"
          matTooltip="Create Template"
          style="width: 50px; height: 50px"
          (click)="addNewTemplate()"
          [disabled]="mode === 'view'"
        >
          <i class="flaticon2-plus"></i>
        </button>
      </div>
      <div class="ks-mr-3 ks-p-3 ks-font-size-sm">
        <mat-slide-toggle formControlName="sequential_order"
          >Sequential
        </mat-slide-toggle>
      </div>
      <div class="p-0">
        <button
          type="button"
          class="btn"
          [ngClass]="form.get('is_externally_completable')?.value
      ? 'btn-light-success'
      : 'btn-light'"
          (click)="onCompletableChange()"
        >
          Completed by external people
        </button>
      </div>
    </div>
    <div class="d-flex align-items-end justify-content-between mt-4">
      <div class="d-flex align-items-center">
        <button
          *ngIf="index"
          mat-raised-button
          class="btn btn-light mr-4"
          (click)="cancelStepUpdate($event)"
        >
          Cancel
        </button>
        <button
          mat-raised-button
          class="btn btn-primary"
          [disabled]="mode === 'view'"
          (click)="addStep($event)"
        >
          {{ index ? 'Update' : 'Add' }} Additional Step
        </button>
      </div>
    </div>
  </form>
  <small class="text-muted"
    >You can manage the order of additional steps by drag and drop it.</small
  >
  <div class="border rounded p-4">
    <div *ngIf="!additionalSteps?.length" class="font-weight-bold text-center w-100">
      There are no steps added!
    </div>
    <ng-container *ngIf="additionalSteps?.length">
      <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
        <div class="col-5">Template</div>
        <div class="col-5">Sequential</div>
        <div class="col-2">Actions</div>
      </div>
      <div
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        class="list-draggable"
        [cdkDropListDisabled]="mode === 'view'"
      >
        <div
          cdkDrag
          *ngFor="let step of additionalSteps; let idx = index"
          class="row border-bottom m-0 mb-2 p-2 w-100 list-draggable-item"
        >
          <div class="col-5">{{ step.task_template?.name }}</div>
          <div class="col-5" [ngClass]="step.sequential_order ? 'text-success' : 'text-danger'">
            {{ step.sequential_order ? 'YES' : 'NO' }}
          </div>
          <div class="col-2" *ngIf="mode !== 'view'">
            <button
              *ngIf="!(_templateId === step?.task_template?.id)"
              class="btn btn-icon btn-sm btn-light btn-hover-primary mr-1"
              [matTooltip]="'TABLE.UPDATE' | translate"
              (click)="updateStep($event, idx, step)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
            <button
              *ngIf="!(_templateId === step?.task_template?.id)"
              class="btn btn-icon btn-sm btn-light btn-hover-danger"
              [matTooltip]="'TABLE.DELETE' | translate"
              (click)="deleteStep($event, step)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
            <label *ngIf="_templateId === step?.task_template?.id" class="text-danger"
              >Original Step</label
            >
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div
  class="alert alert-custom alert-outline-2x alert-outline-danger fade show mb-5"
  role="alert"
  *ngIf="!canSetAdditionalSteps"
  style="width: 100%"
>
  <div class="alert-icon"><i class="flaticon-warning"></i></div>
  <div class="alert-text">
    This template is a step of another one, so you can't include more steps in it, Or it might be an
    intervention task template.
  </div>
</div>
